import request from '@/utils/request'

const tradeSellContractApi = {
  trade_sell_contract_list: '/trade/sell_contract/',
  trade_sell_contract_create: '/trade/sell_contract/',
  trade_sell_contract_update: '/trade/sell_contract/',
  trade_sell_contract_delete: '/trade/sell_contract/',
  trade_sell_contract_to_jd: '/trade/sell_contract_to_jd/',
  trade_sell_contract_archived: '/trade/sell_contract_archived/',
  trade_sell_contract_settlement_volume: '/trade/sell_contract_settlement_volume/',
  trade_sell_contract_fixed_pricing: '/trade/sell_contract_fixed_pricing/',
  trade_sell_contract_point_pricing: '/trade/sell_contract_point_pricing/',
  trade_sell_contract_by_unit_price_type: '/trade/sell_contract_by_unit_price_type/',
  trade_sell_contract_floating_pricing: '/trade/sell_contract_floating_pricing/',
  trade_sell_contract_modify_record: '/trade/sell_contract_modify_record/',
  trade_sell_contract_valence_vertex_price: '/trade/sell_contract_valence_vertex_price/',
  trade_sell_contract_related_valence_vertex: '/trade/sell_contract_related_valence_vertex/',
  trade_sell_contract_fixed_pricing_details: '/trade/sell_contract_fixed_pricing_details/'
}

/**
 * 列表
 */
export function sell_contract_fixed_pricing_list (parameter) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_fixed_pricing,
    method: 'get',
    timeout: 600000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 列表
 */
export function sell_contract_point_pricing_list (parameter) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_point_pricing,
    method: 'get',
    timeout: 600000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 列表
 */
export function sell_contract_floating_pricing_list (parameter) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_floating_pricing,
    method: 'get',
    timeout: 600000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 列表
 */
export function sell_contract_list (parameter) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_list,
    method: 'get',
    timeout: 600000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function sell_contract_create (parameter) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function sell_contract_update (parameter, sell_contract_id) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_update + sell_contract_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function sell_contract_delete (sell_contract_id) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_delete + sell_contract_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 修改
 */
export function sell_contract_to_jd (sell_contract_id) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_to_jd,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    timeout: 60000,
    data: {
      id: sell_contract_id
    }
  })
}

/**
 * 购销合同修改状态
 * @param parameter
 * @param sell_contract_id
 * @returns {AxiosPromise}
 */
export function sell_contract_archived (parameter) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function sell_contract_settlement_volume_list (parameter) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_settlement_volume,
    method: 'get',
    timeout: 600000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 购销合同修改记录
 */
export function sell_contract_modify_record_list (parameter) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_modify_record,
    method: 'get',
    timeout: 600000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 购销合同-点价-点价明细列表
 */
export function sell_contract_valence_vertex_price_list (parameter) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_valence_vertex_price,
    method: 'get',
    timeout: 600000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 创建 购销合同-点价-点价明细
 * @param data 传参
 */
export function sell_contract_valence_vertex_price_create (data) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_valence_vertex_price,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })
}

export function sell_contract_valence_vertex_price_delete (id) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_valence_vertex_price + id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 列表
 */
export function sell_contract_related_valence_vertex_list (parameter) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_related_valence_vertex,
    method: 'get',
    timeout: 600000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 关联 购销合同-点价
 * @param data 传参
 */
export function sell_contract_related_valence_vertex_create (data) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_related_valence_vertex,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })
}

export function sell_contract_related_valence_vertex_delete (id) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_related_valence_vertex + id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 列表
 */
export function sell_contract_by_unit_price_type_list (parameter) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_by_unit_price_type,
    method: 'get',
    timeout: 600000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

export function sell_contract_fixed_price_details_create (parameter) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_fixed_pricing_details,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function trade_sell_contract_fixed_pricing_details (parameter) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_fixed_pricing_details,
    method: 'get',
    timeout: 600000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

export function sell_contract_fixed_price_details_delete (id) {
  return request({
    url: tradeSellContractApi.trade_sell_contract_fixed_pricing_details + id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
